var _jsxFileName = "/repo/packages/webassets/src/components/SPAPageContent/index.js",
  _this = this;
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { SPARouteMetricsProvider } from '@sm/metrics';
import { useLocation } from 'react-router-dom';
import { StaticContext } from '../..';
var SPAPageContent = function SPAPageContent(_ref) {
  var children = _ref.children,
    pageId = _ref.pageId,
    pageMetricsAttributes = _ref.pageMetricsAttributes,
    legacyWeb = _ref.legacyWeb;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var _useContext = useContext(StaticContext),
    user = _useContext.user,
    environment = _useContext.environment,
    GDPR = _useContext.GDPR;
  var country = environment.countryCode;
  return /*#__PURE__*/React.createElement(SPARouteMetricsProvider, {
    pageId: pageId,
    legacyWeb: legacyWeb,
    pathname: pathname,
    attributes: pageMetricsAttributes,
    GDPR: GDPR,
    user: user,
    country: country,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 5
    }
  }, children);
};
SPAPageContent.propTypes = {
  legacyWeb: PropTypes.string,
  pageId: PropTypes.string.isRequired,
  pageMetricsAttributes: PropTypes.shape({}),
  children: PropTypes.node.isRequired
};
SPAPageContent.defaultProps = {
  legacyWeb: undefined,
  pageMetricsAttributes: null
};
export default SPAPageContent;
//# sourceMappingURL=index.js.map